import { apiUrl } from "../utils/api";
import { apiFetch } from "../utils/apiFetch";

/** Konfigurierbare Haushaltsrolle (Dropdown „Rolle im Haushalt"). */
export interface HouseholdRole {
  id: number;
  key: string;
  label: string;
  sortOrder: number;
  aktiv: boolean;
}

/** Konfigurierbares Beziehungs-Label (manuelles Beziehungs-Dropdown). */
export interface HouseholdRelationLabel {
  id: number;
  label: string;
  sortOrder: number;
  aktiv: boolean;
}

export type HouseholdRoleInput = { label: string; sortOrder?: number; aktiv?: boolean };
export type HouseholdRelationLabelInput = { label: string; sortOrder?: number; aktiv?: boolean };

async function mutate<T>(path: string, method: "POST" | "PUT" | "DELETE", body?: unknown): Promise<T | null> {
  const res = await fetch(apiUrl(path), {
    method,
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = `Fehlgeschlagen: HTTP ${res.status}`;
    try {
      const d = await res.json();
      if (d?.message) msg = Array.isArray(d.message) ? d.message.join(", ") : String(d.message);
    } catch {
      /* ignore */
    }
    throw new Error(msg);
  }
  if (method === "DELETE") return null;
  return (await res.json()) as T;
}

// ── Haushaltsrollen ──────────────────────────────────────────────
export const listHouseholdRoles = async (): Promise<HouseholdRole[]> => {
  const { data } = await apiFetch<HouseholdRole[]>("household-role");
  return Array.isArray(data) ? data : [];
};
export const createHouseholdRole = (input: HouseholdRoleInput) =>
  mutate<HouseholdRole>("household-role", "POST", input);
export const updateHouseholdRole = (id: number, input: Partial<HouseholdRoleInput>) =>
  mutate<HouseholdRole>(`household-role/${id}`, "PUT", input);
export const deleteHouseholdRole = (id: number) =>
  mutate<void>(`household-role/${id}`, "DELETE");

// ── Beziehungs-Labels ────────────────────────────────────────────
export const listHouseholdRelationLabels = async (): Promise<HouseholdRelationLabel[]> => {
  const { data } = await apiFetch<HouseholdRelationLabel[]>("household-relation-label");
  return Array.isArray(data) ? data : [];
};
export const createHouseholdRelationLabel = (input: HouseholdRelationLabelInput) =>
  mutate<HouseholdRelationLabel>("household-relation-label", "POST", input);
export const updateHouseholdRelationLabel = (id: number, input: Partial<HouseholdRelationLabelInput>) =>
  mutate<HouseholdRelationLabel>(`household-relation-label/${id}`, "PUT", input);
export const deleteHouseholdRelationLabel = (id: number) =>
  mutate<void>(`household-relation-label/${id}`, "DELETE");
